<template>
<div>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :close-on-press-escape="false"
    :show-close="false"
    class="login-dialog-container"
    custom-class="login-wrap"
  >
    <div class="inviter-avatar">
      <img :src="inviterAvatar" alt="">
    </div>
    <p class="invite-text">
      <span>{{inviterName}}</span>
      <span>{{$t('components_login_ref_index_1102')}}</span>
    </p>
    
    <p class="invite-text">{{$t('components_login_ref_index_1103')}}</p>
    <div class="red-packet-wrap">
      <img class="red-packet" src="~@/assets/images/invite-friend.png" alt="">
    </div>
    <p class="invite-bottom-text">{{$t('components_login_ref_index_1104')}}</p>
    <div class="login-body">
      <div class="login-body-line mobile">
        <div
          class="mobile-prefix"
        >
          <el-popover
            v-model="isShowMobileAreaSelectList"
            :visible-arrow="false"
            popper-class="popper-clear-style"
            placement="bottom-start"
          >
            <div slot="reference" class="mobile-prefix-inner">
              <span>{{ currentSelectPrefix.code }}</span>
              <img src="~@/assets/images/select-icon.png" alt="" />
            </div>
            <div
              class="login-dialog-body-mobile-area"
            >
              <p
                v-for="(item, index) in mobileAreaList"
                :key="index"
                @click="selectMobileArea(item.code)"
              >
                <span>{{ item.text }}</span>
                <span>{{ item.code }}</span>
              </p>
            </div>
          </el-popover>
        </div>
        <div class="mobile-input">
          <input v-model="loginObj.phoneNumber" type="text" :placeholder="$t('upgrade_page_views_user_set_account_783')" />
        </div>
      </div>
      <div class="login-body-line code">
        <div class="valid-code">
          <input v-model="loginObj.verifyCode" type="text" :placeholder="$t('upgrade_page_views_user_set_account_785')" />
        </div>
        <div class="btn">
          <button
            :disabled="sendCodeTimer > 0"
            @click="getValidateCode"
          >
            <span v-if="isSendingSmsCode">
              <i class="el-icon-loading"></i>{{$t('upgrade_page_views_user_set_account_786')}}</span>
            <span v-else>{{ sendCodeTimer > 0 ? $t('components_login_components_phone_login_1077') + sendCodeTimer + ')' : $t('upgrade_page_views_user_set_account_787') }}</span>
          </button>
        </div>
      </div>
      <div class="login-body-operation">
        <p @click="changeIsKeepLoginStatus">
          <img :src="isKeepLoginStatus ? checked : unchecked" alt="">
          <span>{{$t('components_login_components_phone_login_1078')}}</span>
        </p>
      </div>
    </div>
    <div class="login-footer">
      <button @click="login" class="primary-btn">
        <i class="el-icon-loading" v-if="isLogining"></i>
        <span v-else>{{$t('components_login_components_phone_login_1079')}}</span>
      </button>
    </div>
    <div class="login-protocol">
      <p>{{$t('components_login_index_1090')}}<span @click="jumpPage('compact')">{{$t('upgrade_page_views_login_index_1093')}}</span>{{$t('upgrade_page_views_login_index_1094')}}<span @click="jumpPage('privacy')">{{$t('upgrade_page_views_login_index_1095')}}</span></p>
    </div>
    <div id="verification-code"></div>
  </el-dialog>

</div>
</template>

<script>
import i18n from '@/locales/index'
import store from '@/store/index'
import { getSmsCode } from '@/api'
import Clickoutside from '@/utils/clickoutside'
import mobileAreaList from '@/utils/areas-code'

export default {
  name: 'refLogin',
  directives: {
    clickoutside: Clickoutside
  },
  data() {
    return {
      isKeepLoginStatus: true,
      isShowMobileAreaSelectList: false,
      mobileAreaList,
      currentSelectPrefix: {
        code: 1
      },
      isSendingSmsCode: false,
      isLogining: false,
      sendCodeTimer: 0,
      initInviterNumber: 0,
      visible: false,
      inviterAvatar: '',
      inviterName: '',
      inviterUnique: '',
      showBindPhone: false,
      loginObj: {
        phoneNumber: '',
        verifyCode: '',
        keyUuid: null,
        inviterUnique: '',
      },
      tencentCaptchaInstance: null,
      timer: null,
    }
  },
  methods: {
    jumpPage(page) {
      this.$util.openWindow(`/${page}`)
    },
    /**
     * @description 是否记住登录状态
     */
    changeIsKeepLoginStatus() {
      this.isKeepLoginStatus = !this.isKeepLoginStatus
    },
    toggleMobileAreaSelectList() {
      this.isShowMobileAreaSelectList = !this.isShowMobileAreaSelectList
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
    /**
     * @description 獲取驗證碼
     */
    getValidateCode() {

      const { phoneNumber } = this.loginObj

      if (!phoneNumber) return this.$message.error(i18n.t('upgrade_page_views_user_set_account_783'))
      
      if (!this.tencentCaptchaInstance) {
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            const { phoneNumber } = this.loginObj
            const { code } = this.currentSelectPrefix

            getSmsCode({
              phoneNumber: code + phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }

              this.isSendingSmsCode = false
            }).catch(() => {
              this.isSendingSmsCode = false
              // this.$message.error('手機號碼錯誤，請重新填寫')
            })
          }
        })
      }

      this.tencentCaptchaInstance.show()
    },
    /**
     * @description 設置發送驗證碼倒計時
     */
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count
      clearTimeout(this.timer)
      if (count > 0) {
        this.timer = setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      }
    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      const { phoneNumber, verifyCode, keyUuid } = this.loginObj
      const { code } = this.currentSelectPrefix
      if (!phoneNumber) {
        this.$message.error(i18n.t('components_login_components_phone_login_1081'))
        return false
      }
      if (verifyCode.length !== 4) {
        this.$message.error(i18n.t('components_login_components_phone_login_1082'))
        return false
      }
      return {
        phoneNumber: code + phoneNumber,
        verifyCode,
        keyUuid,
        isSaveToken: this.isKeepLoginStatus,
        inviterUnique: window.localStorage.getItem('STORAGE_INVITER_UUID') ? null : this.inviterUnique,
        hasInvitedFive: window.localStorage['REGISTER_NUM_'+this.inviterUnique] && window.localStorage['REGISTER_NUM_'+this.inviterUnique].length > 5 ? true : false
      }
    },
    /**
     * @description 登陸
     */
    async login() {
      const params = this.validateInputMsg()
      console.log(params)
      if (params && !this.isLogining) {
        this.isLogining = true
        try {
          await store.dispatch('app/login', params)
          this.isLogining = false
          this.visible = false
          this.isEmpty()
          this.beforeSuccess()
        } catch(e) {
          this.isLogining = false
        }
      }
    },
    beforeSuccess() {
      let isLogin = false
      const userInfo = store.getters.userInfo
      if (userInfo.isNewRegistration) {
        if(userInfo.phoneNumber.substring(0, 3) !== '886') {
          this.$message({
            message: i18n.t('components_login_components_phone_login_1083')
          })
        } else if (!userInfo.hasRedBag) {
          this.$message({
            message: i18n.t('components_login_components_phone_login_1084')
          })
        }
      } else {
        isLogin = true
      }
      this.success({ isLogin })
    },
    success() {
    },
    isEmpty(){
      this.loginObj.verifyCode = ''
      this.setSmsCodeInterval(0)
    }
  }
}
</script>

<style lang="scss" scoped>
  
  @media screen and (min-width: 600px) {
    .login-dialog-container {
      & /deep/ .el-dialog{
        width: 386px;
      }
      & /deep/ .el-dialog__header {
        padding: 0;
      }

      & /deep/ .el-dialog__body {
        padding-bottom: 50px;
        padding-top: 70px;
      }
    }
    .login-wrap {
      height: 422px;
      padding: 30px 20px 50px;

      .login-title {
        color: #333;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
      }
      .inviter-avatar {
        width: 98px;
        height: 98px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        top: -45px;
        border-radius: 100%;
        background: white;
        img {
          width: 90px;
          height: 90px;
          border-radius: 100%;
        }
      }
      .invite-text {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.03em;
        text-align: center;
        color: #333333;
        span:first-child {
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #333333;
          width: 82px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
        }
  
      }
      .red-packet-wrap {
        display: flex;
        justify-content: center;
        margin: 10px 0 15px 0;
        .red-packet {
          width: 157px;
          height: 107px;
        }
      }
      .invite-bottom-text {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        color: #666666;
      }
      .login-body {
        position: relative;
        padding: 30px 28px 0;
        margin-top: 10px;
      }

      .login-footer {
        margin: 20px auto 0;

        button {
          @include flex();
          width: 290px;
          height: 46px;
          margin: auto;
        }
      }

      .login-protocol {
        margin-top: 20px;
        font-size: 13px;
        line-height: 18px;
        color: #666;
        text-align: center;

        span {
          cursor: pointer;
          text-decoration: underline;
          color: $color-gray-1;
        }
      }

      .login-body-line {
        @include flex();
        height: 46px;
        border-radius: 4px;
        font-size: 16px;

        > div {
          @include flex();
          height: 100%;
        }

        &.mobile {
          border: 1px solid #999999;
          padding: 0 13px 0 0;
        }

        &.code {
          margin-top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          color: #333;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }

        .mobile-prefix {
          width: 55px;
          flex-shrink: 0;
          cursor: pointer;

          .mobile-prefix-inner {
            @include flex(space-between);
            width: 58px;
            padding-left: 13px;
          }

          img {
            width: 10px;
            height: 10px;
            margin-left: 2px;
          }
        }

        .mobile-input {
          flex-grow: 1;
          margin-left: 14px;
          input{
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
          }
        }

        .valid-code {
          width: 164px;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 13px;
        }

        .btn {
          width: 116px;
          margin-left: 10px;

          button {
            @include flex();
            width: 100%;
            height: 100%;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px; 
            border-radius: 4px;
            cursor: pointer;
            background: linear-gradient(151.37deg, #FF4417 2.04%, #FB006E 60.91%);
          }
        }
      }

      .login-body-operation {
        display: inline-block;
        font-size: 0;
        margin-top: 40px;

        p {
          @include flex(flex-start);
          cursor: pointer;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }

        span {
          font-size: 13px;
          color: #666;
          line-height: 18px;
        }
      }
    }

    .login-dialog-body-mobile-area {
      width: 290px;
      height: 228px;
      overflow: auto;
      border-radius: 4px;
      border: 1px solid #999;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

      p {
        @include flex(space-between);
        color: #333;
        font-size: 16px;
        height: 38px;
        margin: 0;
        padding: 0 9px;
        font-weight: 400;
        transition: all .2s ease;
        cursor: pointer;
        background: white;

        &:hover {
          background: #f6f6f6;
        }

        span:first-child {
          @include ellipsis;
        }
      }
    }
  }
  
  @media screen and (max-width: 599px) {
    .login-dialog-container {
      & /deep/ .el-dialog{
        width: 343px !important;
        max-width: 91vw;
        border-radius: 8px;
      }
      & /deep/ .el-dialog__header {
        padding: 0;
      }

      & /deep/ .el-dialog__body {
        padding-bottom: 50px;
        box-sizing: border-box;
        padding-top: 70px;
      }
    }
    .login-wrap {
      height: 422px;

      .login-title {
        color: #333;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
      }
      .inviter-avatar {
        width: 98px;
        height: 98px;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        top: -45px;
        border-radius: 100%;
        background: white;
        img {
          width: 90px;
          height: 90px;
          border-radius: 100%;
        }
      }
      .invite-text {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.03em;
        text-align: center;
        color: #333333;
        span:first-child {
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #333333;
          width: 82px;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
        }
  
      }
      .red-packet-wrap {
        display: flex;
        justify-content: center;
        margin: 10px 0 15px 0;
        .red-packet {
          width: 157px;
          height: 107px;
        }
      }
      .invite-bottom-text {
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        color: #666666;
      }
      .login-body {
        position: relative;
        padding: 30px 7px 0 6px;
        box-sizing: border-box;
        margin-top: 10px;
        border-top: 1px solid #e0e0e0;
      }

      .login-footer {
        margin: 20px auto 0;
        button {
          @include flex();
          width: 76vw;
          max-width: 290px;
          height: 46px;
          margin: auto;
        }
      }

      .login-protocol {
        margin-top: 20px;
        font-size: 13px;
        line-height: 18px;
        color: #666;
        text-align: center;

        span {
          cursor: pointer;
          text-decoration: underline;
          color: $color-gray-1;
        }
      }

      .login-body-line {
        @include flex(space-between,center,row);
        height: 46px;
        border-radius: 4px;
        font-size: 16px;

        > div {
          @include flex();
          height: 100%;
        }

        &.mobile {
          border: 1px solid #999999;
          padding: 0 13px 0 0;
        }

        &.code {
          margin-top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          color: #333;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }

        .mobile-prefix {
          width: 55px;
          flex-shrink: 0;
          cursor: pointer;

          .mobile-prefix-inner {
            @include flex(space-between);
            width: 58px;
            padding-left: 13px;
          }

          img {
            width: 10px;
            height: 10px;
            margin-left: 2px;
          }
        }

        .mobile-input {
          flex-grow: 1;
          margin-left: 14px;
          input{
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0); 
          }
        }

        .valid-code {
          width: 48vw;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 0 13px;
        }

        .btn {
          width: 34vw;
          margin-left: 10px;

          button {
            @include flex();
            width: 100%;
            height: 100%;
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px; 
            border-radius: 4px;
            cursor: pointer;
            background: linear-gradient(151.37deg, #FF4417 2.04%, #FB006E 60.91%);
          }
        }
      }

      .login-body-operation {
        display: inline-block;
        font-size: 0;
        margin-top: 40px;

        p {
          @include flex(flex-start);
          cursor: pointer;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 6px;
        }

        span {
          font-size: 13px;
          color: #666;
          line-height: 18px;
        }
      }
    }

    .login-dialog-body-mobile-area {
      width: 290px;
      max-width: 77vw;
      height: 228px;
      overflow: auto;
      border-radius: 4px;
      border: 1px solid #999;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: 320px) {
        width: 75vw;
      }
      p {
        @include flex(space-between);
        color: #333;
        font-size: 16px;
        height: 38px;
        margin: 0;
        padding: 0 9px;
        font-weight: 400;
        transition: all .2s ease;
        cursor: pointer;
        background: white;

        &:hover {
          background: #f6f6f6;
        }

        span:first-child {
          @include ellipsis;
        }
      }
    }
  }
</style>
